<template>
  <b-modal v-model="modalVisible" centered hide-footer :title="keg.kid" size="sm">
    <template #default>
      <div class="keg-info-modal">
        <div class="d-flex justify-content-between">
          <span class="text-secondary">{{ formatDate(keg.create_at) }}</span>
          <!-- <span><a href="#" class="text-secondary">編輯資料</a></span> -->
        </div>

        <p>{{ keg.isReused? '再利用': '新品' }} | {{ keg.sizeModel }}</p>
        <hr/>

        <div>
          <div class="row mb-3">
            <div class="col-auto">
              <label for="">
                借用狀態
              </label>
            </div>

            <div class="col" v-if="editable">
              <b-button variant="primary" size="sm" @click="statusChangeModalShow = true">
                {{ formatStatus(keg.status) }}
              </b-button>
            </div>
            <div class="col" v-else>
              <b-badge variant="primary" size="sm">
                {{ formatStatus(keg.status) }}
              </b-badge>
            </div>

          </div>
          <p class="text-right">
            <a href="#" class="text-secondary" @click.prevent="kegHistoryModalShow = true">歷史紀錄</a>
          </p>
        </div>

        <div v-if="keg.status === 1">
          <div class="row">
            <div class="col-auto">
              <label for="" class="text-secondary">
                出借日期
              </label>
            </div>

            <div class="col text-secondary">
              {{ formatDate(keg.lastStatusChangeTime) }}
            </div>
          </div>

          <div class="row">
            <div class="col-auto">
              <label for="" class="text-secondary">
                累計天數
              </label>
            </div>

            <div class="col text-secondary">
              {{ formatDateUntilNow(keg.lastStatusChangeTime) }}
            </div>
          </div>

          <div class="row">
            <div class="col-auto">
              <label for="" class="text-secondary">
                客戶名稱
              </label>
            </div>

            <div class="col text-secondary">
              {{ keg.cname }}
            </div>
          </div>

          <div class="row">
            <div class="col-auto">
              <label for="" class="text-secondary">
                負責業務
              </label>
            </div>

            <div class="col text-secondary">
              {{ keg.salesman }}
            </div>
          </div>
        </div>

        <div v-if="keg.status === 0">
          <div class="row mb-3">
            <div class="col-auto">
              <label for="">
                清洗進度
              </label>
            </div>
  
            <div class="col">
              <b-button variant="primary" size="sm" @click="washedChangeModalBtnClicked">
                {{ keg.washed? '已清洗': '未清洗' }}
              </b-button>
            </div>
          </div>
  
          <div class="row mb-3">
            <div class="col-auto">
              <label for="">
                填充階段
              </label>
            </div>
  
            <div class="col">
              <b-button variant="primary" size="sm" @click="filledChangeModalBtnClicked">
                {{ keg.filled? '已填充': '未填充' }}
              </b-button>
            </div>
          </div>

        </div>

        <hr/>

        <b-button class="w-100" v-if="editable" @click="deleteBtnClicked">
          刪除
        </b-button>

        <KegStatusChangeModal v-model="statusChangeModalShow" :keg="keg"></KegStatusChangeModal>
        <KegWashedChangeModal v-model="washedChangeModalShow" :keg="keg"></KegWashedChangeModal>
        <KegFilledChangeModal v-model="filledChangeModalShow" :keg="keg"></KegFilledChangeModal>
        <KegHistoryModal v-model="kegHistoryModalShow" :kid="keg.kid"></KegHistoryModal>
      </div>
    </template>
  </b-modal>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import moment from 'moment';
import KegStatusChangeModal from "./KegStatusChangeModal.vue";
import KegWashedChangeModal from "./KegWashedChangeModal.vue";
import KegFilledChangeModal from "./KegFilledChangeModal.vue";
import KegHistoryModal from "./KegHistoryModal.vue";

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegInfoModal',
  data() {
    return {
      statusChangeModalShow: false,
      washedChangeModalShow: false,
      filledChangeModalShow: false,
      kegHistoryModalShow: false,
    };
  },
  components: {
    KegStatusChangeModal,
    KegWashedChangeModal,
    KegFilledChangeModal,
    KegHistoryModal,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
    keg: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

  },
  watch: {
    
  },
  mounted() {
  },
  methods: {
    formatDate(timestamp) {
      return moment(timestamp).format('YYYY/MM/DD');
    },
    formatStatus(s) {
      switch(s) {
        case 0:
          return '在庫';
        case 1:
          return '出借';
        case 2:
          return '失蹤';
        case 3:
          return '退役';
      }
      return '';
    },
    formatDateUntilNow(timestamp) {
      const m = moment.duration(moment().diff(moment(timestamp)));
      return `${parseInt(m.asDays())} 天`;
    },
    async deleteBtnClicked() {
      try {
        const r = await this.$bvModal.msgBoxConfirm('確定刪除此資料嗎?', {
          title: '刪除確認',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: '確認刪除',
          cancelTitle: '取消',
          hideHeaderClose: false,
          centered: true
        });
        if (r) {
          await this.handleAsyncTask(() => this.$store.dispatch('keg/deleteKegs', [this.keg.serial]));
          this.modalVisible = false;
          await this.$bvModal.msgBoxOk('刪除成功!');
        }
      } catch (error) {
        console.error(error);
      }
          
    },
    washedChangeModalBtnClicked() {
      if (this.editable) {
        this.washedChangeModalShow = true;
      }
    },
    filledChangeModalBtnClicked() {
      if (this.editable) {
        this.filledChangeModalShow = true;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.keg-info-modal {
  color: $color-primary;
}
</style>
